import PageShell from "../components/layout/PageShell";
import AgencyDashboard from "./dashboard/AgencyDashboard";
import SuperAdminDashboard from "./dashboard/SuperAdminDashboard";
import ClientDashboard from "./dashboard/ClientDashboard";
import {
    isSuperAdminUser,
    isAgencyUser
} from "../services/authService";
import "./dashboard.css";

export default function DashboardPage() {
    const isSuperAdmin = isSuperAdminUser();
    const isAgency = isAgencyUser();

    return (
        <PageShell title="Dashboard">
            {isSuperAdmin ? (
                <SuperAdminDashboard />
            ) : isAgency ? (
                <AgencyDashboard />
            ) : (
                <ClientDashboard />
            )}
        </PageShell>
    );
}